<template>
    <div id="NotificationBanner">
        <a-row class="top_content">
            <a-col>
                <a-radio-group v-model="mode">
                    <a-radio-button value="top">
                        NewsLetter
                    </a-radio-button>
                    <a-radio-button value="left">
                        Industry
                    </a-radio-button>
                    <a-radio-button value="center">
                        Lenovo
                    </a-radio-button>
                </a-radio-group>
            </a-col>
        </a-row>
        <a-row>
            <a-col>
                <ul class="notice-content">
                    <li v-for="(item, index) in data" :key="index">
                        <NotificationItem :data="item"></NotificationItem>
                    </li>
                </ul>
            </a-col>
        </a-row>

    </div>
</template>

<script>
    import NotificationItem from './NotificationItem'

    export default {
        name: "NotificationBanner",
        props: ['data'],
        components: {
            NotificationItem
        },
        data() {
            return {
                mode: 'top',
                array: []
            }
        },
        destroyed() {
        },
        created() {
        },
        methods: {}
    }
</script>

<style lang="less" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #NotificationBanner {
        max-height: 400px;
        overflow:hidden;
    }
    .top_content{
        height: 40px;
    }


    .notice-content {
        background-color: #eeeeee;
        overflow-y: auto;
        overflow-x: hidden;
        height: 100%;
        max-height: 360px;
        li {
            list-style: none;
            border: 1px solid #40a9ff;
            overflow: hidden;
            background-color: #ffffff;
            margin-top: 5px;
        }
    }

</style>
